import moment from 'moment';
import { IDateProvider } from './../../interfaces/IDateProvider';
export const useDate = (): IDateProvider => {
  const format = (date: Date | string, mask: string): string => {
    const preparedDate = new Date(date);
    return moment(preparedDate.toISOString()).format(mask);
  };
  const isValid = (date: Date | string): boolean => {
    const preparedDate = new Date(date);
    return moment(preparedDate.toISOString()).isValid();
  };
  const isValidWithMask = (date: Date | string, mask: string): boolean => {
    const preparedDate = new Date(date);
    return moment(preparedDate.toISOString(), mask, true).isValid();
  };

  return { format, isValid, isValidWithMask };
};
